import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Table } from 'react-bootstrap'
import { IModeratorPermissionsModel } from 'models/moderatorPermissions.model'
import { PermissionsTypes } from 'enum/permissionsType'
import styles from './PermissionsTable.module.scss'
import PermissionsTableRow from './permissions-table-row/PermissionsTableRow'
import { usePermissionsConditioned } from './usePermissionsConditioned'

interface IPermissionsTable {
  profiles?: any[]
  courses?: any[]
  variant: PermissionsTypes
  setData: any
  data: IModeratorPermissionsModel[]
  onDelete: any
}

const PermissionsTable: React.FC<IPermissionsTable> = ({
  variant,
  setData,
  data,
  profiles = [],
  courses = [],
  onDelete,
}) => {
  const { t } = useTranslation()
  const prefix = 'configuration.user.permissionsManagementModal'

  const aux = useMemo(
    () => new Map(data.map((item) => [item.selected?.value, item])),
    [data]
  )

  const profilesList = useMemo(
    () => profiles.filter((profile: any) => !aux.has(profile.value)),
    [aux, profiles]
  )

  const coursesList = useMemo(
    () => courses.filter((course: any) => !aux.has(course.value)),
    [aux, courses]
  )

  const { editCourse, manageCourses } = usePermissionsConditioned(variant)

  return (
    <div>
      <div className={styles.title}>
        {t(`${prefix}.tabs.${variant}.description`)}
      </div>
      <div className={styles.tableContainer}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.firstTab}>
                {t(`${prefix}.tabs.columns.${variant}.title`)}
              </th>
              <th>{t(`${prefix}.tabs.columns.seeMonitoring`)}</th>
              {editCourse && <th>{t(`${prefix}.tabs.columns.editCourses`)}</th>}
              {manageCourses && (
                <th>{t(`${prefix}.tabs.columns.manageCourses`)}</th>
              )}
              <th>{t(`${prefix}.tabs.columns.chat`)}</th>
              <th className="pr-1">
                {t(`${prefix}.tabs.columns.reportsDownload`)}
              </th>
              <th className="pr-1">
                {t(`${prefix}.tabs.columns.approveRequests`)}
              </th>
              <th className="pr-1">
                {t(`${prefix}.tabs.columns.seeMonitoringAreas`)}
              </th>
              <th className={styles.lastTab}></th>
            </tr>
          </thead>
          <tbody>
            {data.map((dataRow, index) => (
              <PermissionsTableRow
                key={`tableRow-${variant}-${index}`}
                index={index}
                variant={variant}
                selectorData={
                  variant === 'profile' ? profilesList : coursesList
                }
                data={dataRow}
                setData={setData}
                onDelete={() => onDelete(index)}
              />
            ))}
            {(data.length < 1 ||
              (data[data.length - 1].selected &&
                (data[data.length - 1].selected?.value >= 0 ||
                  !!data[data.length - 1].selected?.length))) && (
              <PermissionsTableRow
                index={data.length}
                variant={variant}
                selectorData={
                  variant === 'profile' ? profilesList : coursesList
                }
                setData={setData}
              />
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default PermissionsTable
